import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import lineChart from '../OrgImages/linechartvisual.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgFundingShowcase = () => {
  const canvasRef = useRef<HTMLDivElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(canvasRef, CANVAS_W, CANVAS_H, 'width');

  return (
    <section className='relative flex h-full w-full flex-col overflow-hidden bg-gradient-to-t from-secondary-brand-50 from-[23%] to-secondary-brand-25 to-[95%]'>
      <div className='shrink-0 px-8 pt-10 lg:px-12 lg:pt-16'>
        <h1 className='m-0 text-display-xl font-bold text-gray-600 tracking-[-1.44px] sm:text-display-md md:text-display-md lg:text-display-2xl xl:text-display-3xl'>
          We meet you <br />
          where you are.
        </h1>
      </div>

      <div ref={canvasRef} className='relative min-h-0 flex-1 overflow-hidden'>
        <div className='absolute inset-x-0 bottom-0 flex justify-center'>
          <div style={wrapperStyle}>
            <div style={canvasStyle}>
              <img
                src={lineChart}
                alt=''
                className='absolute'
                style={{ bottom: 0, left: 0, width: 640, height: 357 }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
